<div class="mat-content">
  @if (!hold) {
  <div class="onholdtemplate">
    <div class="title">Add reason for hold.</div>
    <mat-form-field appearance="outline">
      <input matInput autoFocus name="reason" [(ngModel)]="reason" />
    </mat-form-field>
    <div class="actions">
      <button
        class="cdx-but-md cdx-but-link primary-btn"
        mat-stroked-button
        mat-dialog-close
      >
        Cancel
      </button>
      <button
        class="cdx-but-lg save"
        color="primary"
        mat-flat-button
        [disabled]="!reason.trim()"
        (click)="onHold()"
      >
        Hold
      </button>
    </div>
  </div>
  } @else {
  <div class="title">Cancel 'OnHold'?</div>
  <div class="actions">
    <button class="cdx-but-lg save" mat-stroked-button mat-dialog-close>
      Cancel
    </button>
    <button
      class="cdx-but-lg save"
      color="primary"
      mat-flat-button
      (click)="onConfirm()"
    >
      Yes
    </button>
  </div>
  }
</div>
